import type { GoodCustomsInformation, PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { isContainerRow } from "@RequestFormV2/sections/PackingList/utils/packingListSplit";

const ROW_CONTENT_FIELDS: (keyof PackingListRow)[] = [
  "container_type",
  "length",
  "width",
  "height",
  "cbm_scope",
  "l_w_h_cbm_piece",
  "l_w_h_cbm_total",
  "units",
  "weight_piece",
  "nmfc_class",
  "additional_field",
  "additional_information",
  "dangerous_good_value",
  "un_number",
  "temperature_control_value",
  "crating_required_by",
  "pickup_stop_key",
  "delivery_stop_key",
];

function hasValue(value: unknown) {
  if (value === null || value === undefined || value === "") return false;
  if (typeof value === "boolean") return value;
  return true;
}

export function isPackingListRowEmpty(row: PackingListRow | undefined) {
  if (!row) return true;

  if (isContainerRow(row)) {
    return !ROW_CONTENT_FIELDS.some((field) => hasValue(row[field]));
  }

  if (hasValue(row.handling_unit) && row.handling_unit !== "") return false;
  if (row.stackable || row.hazardous || row.crating_required || row.temperature_control_required || row.is_dangerous_good) {
    return false;
  }

  return !ROW_CONTENT_FIELDS.some((field) => hasValue(row[field]));
}

export function isCommodityRowEmpty(commodity: GoodCustomsInformation | undefined) {
  if (!commodity) return true;
  if (commodity.parent_assigned === true) return false;
  return (
    !["hs_code", "description", "currency_code", "origin_country"].some((field) =>
      hasValue(commodity[field as keyof GoodCustomsInformation]),
    ) && !hasValue(commodity.value)
  );
}
